import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowRight, Save, Loader2 } from 'lucide-react';
import { useCreateDelegate } from '../hooks/useDelegates';
import { api } from '../lib/api';

export default function CreateDelegatePage() {
  const navigate = useNavigate();
  const { id } = useParams();
  const isEditMode = !!id;
  const createMutation = useCreateDelegate();
  
  const [formData, setFormData] = useState({ name: '', phone: '', email: '', address: '', city: 'Cairo', area: 'مصر الجديدة' });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await createMutation.mutateAsync({ ...formData, branchId: 1, isActive: true });
      alert('تمت العملية بنجاح');
      navigate('/delegates');
    } catch (err: any) {
      alert('خطأ أثناء الحفظ');
    }
  };

  return (
    <div className="p-6" dir="rtl">
      <h1 className="text-xl font-bold mb-4">{isEditMode ? 'تعديل مندوب' : 'إضافة مندوب جديد'}</h1>
      <form onSubmit={handleSubmit} className="space-y-4 bg-white p-4 rounded shadow">
        <input className="w-full border p-2 rounded" placeholder="الاسم" value={formData.name} onChange={e => setFormData({...formData, name: e.target.value})} />
        <input className="w-full border p-2 rounded" placeholder="الهاتف" value={formData.phone} onChange={e => setFormData({...formData, phone: e.target.value})} />
        <button type="submit" className="bg-orange-600 text-white px-4 py-2 rounded flex items-center gap-2">
          {createMutation.isPending ? <Loader2 className="animate-spin" /> : <Save size={18} />}
          حفظ
        </button>
      </form>
    </div>
  );
}
